
import http from "@/http"

export default {
    namespaced: true,

    state: {
        facility: null,
        filters: [],
        pagination: null,
        tenants: []
    },

    mutations: {
        setFacility (state, data) {
            state.facility = { ...data }
        },

        setFilters (state, data) {
            state.filters = data.slice()
        },

        setPagination (state, data) {
            state.pagination = { ...data }
        },

        setTenants (state, data) {
            state.tenants = data
        }
    },

    actions: {
        loadFacility ({ commit, rootState }) {
            if (rootState.user && rootState.user.facility_id) {
                return http("/api/managers/facility").then(response => {
                    if (!response.data.error) {
                        commit("setFacility", response.data)
                    }

                    return response
                })
            }
        },

        async loadFilters ({ commit, rootState }) {
            if (rootState.user.facility_id) {
                const facilityId = rootState.user.facility_id

                const { data: filters } = await http(`/api/facilities/${facilityId}/tenant-filters`)

                commit("setFilters", filters)
            }
        },

        async loadTenants ({ commit, rootState }) {
            if (rootState.user.facility_id) {
                const facilityId = rootState.user.facility_id

                const { data: { data, pagination } } = await http(`/api/facilities/${facilityId}/tenants`)

                commit("setPagination", pagination)
                commit("setTenants", data)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/userFacility.js